import { render, staticRenderFns } from "./Complain.vue?vue&type=template&id=b0687642&scoped=true&"
import script from "./Complain.vue?vue&type=script&lang=ts&"
export * from "./Complain.vue?vue&type=script&lang=ts&"
import style0 from "./Complain.vue?vue&type=style&index=0&id=b0687642&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0687642",
  null
  
)

export default component.exports